module.exports = __webpack_public_path__ + "cdab57cfee201f1a48ea74968140b148.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/cities-countries/Rome2.jpg
// module id = 3332
// module chunks = 0